import { useAtomValue } from "jotai";
import { Suspense } from "react";
import { IconButton, Tooltip } from "@zapier/design-system";
import {
  AssetType,
  assetAccessAtomFamily_SUSPENDS,
  capitalizedAssetTypeDisplayAtom,
} from "@zapier/canvas-state";
import styles from "./AssetAccessChecker.module.css";

type Props = {
  assetId: string | undefined | null;
  interfaceProjectId: string | undefined;
  assetType: AssetType;
};

type LockIconButtonProps = {
  tooltipContent: string;
};

function LockIconButton({ tooltipContent }: LockIconButtonProps) {
  return (
    <div className={styles.root}>
      <Tooltip placement="top" content={tooltipContent}>
        <IconButton name="actionLock" variant="tertiary" size="small" />
      </Tooltip>
    </div>
  );
}

function SuspendedComponent({ assetId, interfaceProjectId, assetType }: Props) {
  const { isAssetForbidden } = useAtomValue(
    assetAccessAtomFamily_SUSPENDS({
      assetId,
      interfaceProjectId,
      assetType,
    }),
  );

  const getAssetDisplayName = useAtomValue(capitalizedAssetTypeDisplayAtom);

  if (isAssetForbidden) {
    const maybeCapitalizedAssetType =
      assetType === "zap"
        ? getAssetDisplayName(assetType)
        : getAssetDisplayName(assetType).toLowerCase();

    return (
      <LockIconButton
        tooltipContent={`You don't have access to this ${maybeCapitalizedAssetType}.`}
      />
    );
  }

  return null;
}

export function AssetAccessChecker(props: Props) {
  return (
    <Suspense fallback={null}>
      <SuspendedComponent {...props} />
    </Suspense>
  );
}
